/** Сохранённые пользовательские цвета палитры (ручка / стикер). */

const MAX_COLORS = 16;

function normalizeHex(hex: string): string | null {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex.trim());
  if (!m) return null;
  return `#${m[1].toLowerCase()}`;
}

type Store = {
  key: string;
  event: string;
  colors: string[];
};

function load(key: string): string[] {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    const out: string[] = [];
    for (const item of parsed) {
      if (typeof item !== "string") continue;
      const hex = normalizeHex(item);
      if (hex && !out.includes(hex)) out.push(hex);
      if (out.length >= MAX_COLORS) break;
    }
    return out;
  } catch {
    return [];
  }
}

function persist(store: Store): void {
  try {
    localStorage.setItem(store.key, JSON.stringify(store.colors));
  } catch {
    /* ignore */
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(store.event));
  }
}

function createStore(key: string, event: string): Store {
  return { key, event, colors: load(key) };
}

const penStore = createStore("wb-pen-custom-colors:v1", "wb-pen-custom-colors");
const stickyStore = createStore("wb-sticky-custom-colors:v1", "wb-sticky-custom-colors");

function getColors(store: Store): string[] {
  return store.colors;
}

function addColor(store: Store, hex: string, reservedPresets: readonly string[]): string[] {
  const normalized = normalizeHex(hex);
  if (!normalized) return store.colors;
  const presets = reservedPresets.map((c) => c.toLowerCase());
  if (presets.includes(normalized)) return store.colors;
  const without = store.colors.filter((c) => c !== normalized);
  store.colors = [normalized, ...without].slice(0, MAX_COLORS);
  persist(store);
  return store.colors;
}

function removeColor(store: Store, hex: string): string[] {
  const normalized = normalizeHex(hex);
  if (!normalized) return store.colors;
  const next = store.colors.filter((c) => c !== normalized);
  if (next.length === store.colors.length) return store.colors;
  store.colors = next;
  persist(store);
  return store.colors;
}

function subscribe(store: Store, onChange: () => void): () => void {
  const handler = () => onChange();
  window.addEventListener(store.event, handler);
  return () => window.removeEventListener(store.event, handler);
}

export const penCustomColors = {
  get: () => getColors(penStore),
  add: (hex: string, presets: readonly string[]) => addColor(penStore, hex, presets),
  remove: (hex: string) => removeColor(penStore, hex),
  subscribe: (cb: () => void) => subscribe(penStore, cb),
};

export const stickyCustomColors = {
  get: () => getColors(stickyStore),
  add: (hex: string, presets: readonly string[]) => addColor(stickyStore, hex, presets),
  remove: (hex: string) => removeColor(stickyStore, hex),
  subscribe: (cb: () => void) => subscribe(stickyStore, cb),
};

export function normalizeColorHex(hex: string): string | null {
  return normalizeHex(hex);
}
